<template>
  <div class="container">
    <div class="main">
      <Classification @upData="handleChange" />
      <el-row class="list" :gutter="20">
        <el-col class="list-item" :span="6" v-for="v in list" :key="v.id">
          <div class="card">
            <div class="card-cover" @click="handleRes(v)">
              <img class="cover-img" :src="v.toolImage" :title="v.toolName" :alt="v.toolName" />
            </div>
            <div class="card-info">
              <h3>{{ v.toolName }}</h3>
            </div>
            <div class="card-params">
              <div>
                <i class="el-icon-view"></i>
                {{ v.toolViewCount }}
              </div>
              <em> 免费 </em>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="text-center c-808695" v-loading="loading">
        <span v-if="!showTip" @click="getList">加载更多...</span>
        <span v-else-if="!list.length">暂无内容</span>
        <span v-else>没有了</span>
      </div>
    </div>
  </div>
</template>

<script>
import Classification from '@/components/Classification .vue'
import { tools } from '@/api/index'
export default {
  name: 'experiments',
  components: { Classification },
  props: [],
  data() {
    return {
      list: [],
      query: {
        category_id: -1,
        toolName: '',
        limit: 20,
        page: 1,
      },
      showTip: false,
      loading: false
    }
  },
  watch: {},
  computed: {},
  created() {
    if (this.$route.query.category || this.$route.query.category === 0) {
      this.query.category_id = this.$route.query.category
    }
    this.getList()
  },
  mounted() {
    let _this = this
    window.onscroll = function () {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
        document.documentElement.scrollLeft || document.body.scrollLeft
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollHeight - (scrollTop + windowHeight) < 50) {
        if (_this.showTip) return
        _this.handleScrollBottom()
      }
    }
  },
  methods: {
    getList() {
      this.loading = true
      console.log(this.$route.query.category);
      tools(this.query).then((res) => {
        const { data } = res.data
        if (data.length < 19) {
          this.showTip = true
        } else {
          this.showTip = false
        }
        if (this.query.page !== 1) {
          data.forEach((v) => {
            this.list.push(v)
          })
        } else {
          this.list = data
        }
        this.loading = false
      })
      let newurl = this.updateQueryStringParameter(
        window.location.href,
        'category',
        this.query.category_id
      )
      window.history.replaceState(
        {
          path: newurl,
        },
        '',
        newurl
      )
    },
    handleChange(id) {
      this.query.page = 1
      this.query.category_id = id
      this.$route.query.category = id
      this.getList()
    },
    handleScrollBottom() {
      this.query.page++
      this.getList()
    },
    handleRes(v) {
      if(!v.toolAddress || v.toolAddress[0] === '#') return
      window.localStorage.setItem('url', v.toolAddress)
      window.localStorage.setItem('title', v.toolName)
      let { href } = this.$router.resolve({path: 'experiment'});
      window.open(href, '_blank');
    },
    updateQueryStringParameter(uri, key, value) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
      var separator = uri.indexOf('?') !== -1 ? '&' : '?'
      if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2')
      } else {
        return uri + separator + key + '=' + value
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  .list {
    &-item {
        flex: 0 0 20%;
        max-width: 20%;
      .card {
        transition: all 0.3s ease;
        display: block;
        background: #fff;
        border-radius: 5px;
        overflow: hidden;
        box-shadow: 0 3px 10px 1px rgb(0 0 0 / 20%);
        &:hover {
          transform: scale(1.04);
        }
        &-cover {
          width: 100%;
          height: 0;
          padding-bottom: 100%;
          overflow: hidden;
          cursor: pointer;
          img {
            width: 100%;
            height: calc((73vw - 100px) / 5);
          }
        }
        &-info {
          padding: 0 1rem;
          h3 {
            font-size: 16px;
            font-weight: normal;
            color: #444;
            height: 19px;
            line-height: 19px;
            overflow: hidden;
          }
        }
        &-params {
          display: flex;
          justify-content: space-between;
          padding: 0.5rem 1rem;
          margin-top: 0.5rem;
          border-top: 1px dashed #e5e5e5;
          em {
            font-size: 18px;
            color: #ff474c;
            font-style: normal;
          }
        }
      }
    }
  }
}
@media (max-width: 800px) {
  .cover-img {
    height: calc((100vw - 40px) / 2) !important;
  }
}
</style>